import React, { useState, useEffect } from "react";
import { Tooltip, Grid, IconButton } from '@material-ui/core';
//import { Link } from 'react-router-dom';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SearchIcon from "@material-ui/icons/Search";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateProductSKU from "./CreateProductSKU";
import UseFetchData from "../../../hooks/UseFetchData";

const ProducViewDtls = ({ ProductID, ProductName }) => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [ProductSKUID, setProductSKUID] = useState('');
  const [Mode, setMode] = useState('');
  const [GstPer, setGstPer] = useState('');
  const [ModelCode, setModelCode] = useState('');
  const [Count, setCount] = useState();
  const [ProductCat1ID, setProductCat1ID] = useState('');
  const [ProductCat2ID, setProductCat2ID] = useState('');
  const [ProductCat3ID, setProductCat3ID] = useState('');
  const [Description, setDescription] = useState('');
  const [Specifications, setSpecifications] = useState('');
  const [ProductCat1cmb, setProductCat1cmb] = useState([]);
  const [ProductCat2cmb, setProductCat2cmb] = useState([]);
  const [ProductCat3cmb, setProductCat3cmb] = useState([]);
  const [responseCmbData, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();

  const openModal = (row) => {
    setProductSKUID(row.id);
    setOpen(true);
    setMode('Update');
  }

  const AddNew = () => {
    setOpen(true);
    setProductSKUID('');
    setMode('Insert');
  }

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("ModelCode", ModelCode);
    bodyFormData.append("ProductCat1ID", ProductCat1ID);
    bodyFormData.append("ProductCat2ID", ProductCat2ID);
    bodyFormData.append("ProductCat3ID", ProductCat3ID);
    bodyFormData.append("Description", Description);
    bodyFormData.append("Specifications", Specifications);
    // bodyFormData.append("GstPer",GstPer);
    fetchData("ProductSKU/List", bodyFormData);
  }

  const GetComboData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ProductID", ProductID);
    fetchComboData("ProductSKU/ComboDataSKU", bodyFormData);
  };

  useEffect(() => {
    if (responseCmbData !== undefined) {
      if (responseCmbData["cmbProductCat1"] !== undefined
        && responseCmbData["cmbProductCat2"] !== undefined
        && responseCmbData["cmbProductCat3"] !== undefined
      ) {
        setProductCat1cmb(responseCmbData["cmbProductCat1"]);
        setProductCat2cmb(responseCmbData["cmbProductCat2"]);
        setProductCat3cmb(responseCmbData["cmbProductCat3"]);
      }
    }
  }, [responseCmbData]);

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "ModelCode",
        headerName: "Model Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "Description",
        headerName: "Description",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
        renderCell: (params) => (
          <Tooltip title={params.row.Description} >
            <span className="table-cell-trucate">{params.row.Description}</span>
          </Tooltip>
        ),
      },
      {
        field: "Specifications",
        headerName: "Specifications",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
        renderCell: (params) => (
          <Tooltip title={params.row.Specifications} >
            <span className="table-cell-trucate">{params.row.Specifications}</span>
          </Tooltip>
        ),
      },
      {
        field: "ProductCat1",
        headerName: "Cat 1",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
        renderCell: (params) => (
          <Tooltip title={params.row.ProductCat1} >
            <span className="table-cell-trucate">{params.row.ProductCat1}</span>
          </Tooltip>
        ),
      },
      {
        field: "ProductCat2",
        headerName: "Cat 2",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
        renderCell: (params) => (
          <Tooltip title={params.row.ProductCat2} >
            <span className="table-cell-trucate">{params.row.ProductCat2}</span>
          </Tooltip>
        ),
      },
      // {
      //   field: "ProductCat3",
      //   headerName: "Cat 3",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 160,
      //   renderCell: (params) => (
      //     <Tooltip title={params.row.ProductCat3} >
      //       <span className="table-cell-trucate">{params.row.ProductCat3}</span>
      //     </Tooltip>
      //   ),
      // },
      // {
      //   field: "ProductCat4",
      //   headerName: "Cat 4",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 160,
      //   renderCell: (params) => (
      //     <Tooltip title={params.row.ProductCat4} >
      //       <span className="table-cell-trucate">{params.row.ProductCat4}</span>
      //     </Tooltip>
      //   ),
      // },
      {
        field: "Unit",
        headerName: "Unit",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      // {
      //   field: "MandrelSpareModelCode",
      //   headerName: "Mandrel Spare Model",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 250,
      // },
      // {
      //   field: "RollerSetSpareModelCode",
      //   headerName: "Roller Set",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      {
        field: "ShippingWeight",
        headerName: "Shipping Weight",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ListPriceINR",
        headerName: "List Price INR",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ListPriceUSD",
        headerName: "List Price USD",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "GstPer",
        headerName: "GST %",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "HSNCode",
        headerName: "HSN Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      // {
      //   field: "Weight_kg",
      //   headerName: "Weight(kg)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "Weight_lbs",
      //   headerName: "Weight(lbs)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "A_F",
      //   headerName: "A_F",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "D1",
      //   headerName: "D1",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "D2",
      //   headerName: "D2",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "T",
      //   headerName: "T",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "C",
      //   headerName: "C",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "OAL",
      //   headerName: "OAL",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "NominalSize",
      //   headerName: "NominalSize",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "OD",
      //   headerName: "OD",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "B",
      //   headerName: "B",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "D",
      //   headerName: "D",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "HeadDia",
      //   headerName: "Head Dia",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "Travel",
      //   headerName: "Travel",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "Travel1",
      //   headerName: "Travel 1",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "Travel_ft",
      //   headerName: "Travel(feet)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "Capacity_lbs",
      //   headerName: "Capacity(lbs)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "BeamWidth_mm",
      //   headerName: "BeamWidth(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "TubeSize_mm",
      //   headerName: "TubeSize(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      {
        field: "TubeSize_Inch",
        headerName: "TubeSize(Inch)",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      // {
      //   field: "MotorPower_HP",
      //   headerName: "MotorPower(HP)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "MotorPower_kw",
      //   headerName: "MotorPower(kw)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "MotorSpeedRPM",
      //   headerName: "MotorSpeed(RPM)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 210,
      // },
      // {
      //   field: "Dimesnions_H_W_D_Inch",
      //   headerName: "Dimesnions HWD(Inch)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 260,
      // },
      // {
      //   field: "FlexibleShaftLength_Feet",
      //   headerName: "FlexibleShaftLength(Feet)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 280,
      // },
      {
        field: "FlexibleShaftLength_Mtrs",
        headerName: "FlexibleShaftLength(Mtrs)",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 280,
      },
      // {
      //   field: "StraightTubeSize_mm",
      //   headerName: "StraightTubeSize(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 250,
      // },
      // {
      //   field: "StraightTubeSize_Inch",
      //   headerName: "StraightTubeSize(Inch)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 250,
      // },
      // {
      //   field: "CurvedTubeSize_mm",
      //   headerName: "CurvedTubeSize(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 240,
      // },
      // {
      //   field: "CurvedTubeSize_Inch",
      //   headerName: "CurvedTubeSize(Inch)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 240,
      // },
      {
        field: "BrushOD_mm",
        headerName: "BrushOD(mm)",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      // {
      //   field: "BrushOD_Inch",
      //   headerName: "BrushOD(Inch)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "ShaftCoreOD_mm",
      //   headerName: "ShaftCoreOD(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 220,
      // },
      // {
      //   field: "ShaftCoreOD_Inch",
      //   headerName: "ShaftCoreOD(Inch)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 220,
      // },
      // {
      //   field: "MinimumID_mm",
      //   headerName: "Min ID(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "MinimumID_Inch",
      //   headerName: "Min ID(Inch)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // },
      // {
      //   field: "MaximumExpansion_mm",
      //   headerName: "Max Expansion(mm)",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 240,
      // },
      {
        field: "MaximumExpansion_Inch",
        headerName: "Max Expansion(Inch)",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 240,
      },
    ];
    setColumns(gridCols);
    if (response !== undefined && response.Response !== false) {
      setRows(response);
      setCount(response.length);
    }
  }, [response]);

  useEffect(() => {
    PopulateData();
    GetComboData();
  }, []);

  return (
    <div>

      <Grid container direction="row" style={{ marginTop: 9, marginLeft: 3 }}>
        <BiztranControls.Input
          label="Model Code"
          id="ModelCode"
          onChange={(e) => setModelCode(e.target.value)}
        // style={{ width: 145 }}
        />
        <BiztranControls.Select
          label="Product Cat1"
          id="ProductCat1"
          options={ProductCat1cmb}
          onChange={(e) => setProductCat1ID(e.target.value)}
        />
        <BiztranControls.Select
          label="Product Cat2"
          id="ProductCat2"
          options={ProductCat2cmb}
          onChange={(e) => setProductCat2ID(e.target.value)}
        />
      </Grid>
      <Grid container direction="row" style={{ marginTop: 10 }}>
        <BiztranControls.Select
          label="Product Cat3"
          id="ProductCat3"
          options={ProductCat3cmb}
          onChange={(e) => setProductCat3ID(e.target.value)}
        />
        <BiztranControls.Input
          label="Description"
          id="Description"
          onChange={(e) => setDescription(e.target.value)}
        />
        <BiztranControls.Input
          label="Specifications"
          id="Specifications"
          onChange={(e) => setSpecifications(e.target.value)}
        />
        {/* <BiztranControls.Button
          text="SEARCH"
          startIcon={<SearchIcon />}
          onClick={() => {
            PopulateData();
          }}
        /> */}
        <Tooltip title="SEARCH">
          <IconButton onClick={() => { PopulateData(); }}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
        <div style={{ float: "left", marginTop: 10, marginLeft: 10, width: "5%" }}>
          <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
        </div>
        <BiztranControls.Button
          text="ADD SKU"
          startIcon={<AddCircleOutlineIcon />}
          style={{ height: "10%", fontSize: 13 }}
          onClick={() => {
            AddNew();;
          }}
        />
        {/* <a href="javascript:;" onClick={() => { AddNew(); }} >ADD SKU</a> */}
      </Grid>
      <BiztranControls.DataGrid
        rowHeight={25}
        headerHeight={34}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        hideFooterPagination={false}
        hideFooter={false}
        Height="380px"
        //Height="720px"
        Width="100%"
      />
      <ModalFrame
        title="Product SKU Details"
        maxWidth="md"
        isOpen={isOpen}
        headerAlign="center"
        setOpen={setOpen}
      >
        <CreateProductSKU
          ProductID={ProductID}
          ProductSKUID={ProductSKUID}
          ProductName={ProductName}
          setOpen={setOpen}
          PopulateData={PopulateData}
          Mode={Mode}
        />
      </ModalFrame>
    </div>
  );
};

export default ProducViewDtls;
